import { createRef } from "react";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import FileSectionBase from "../../../commonComponents/fileBase";
import { timeOutMins } from "../../../../base/basicComponents/modal/controlPageBehavior";
import NormalModal, { ModalWithScroll } from "../../../../base/basicComponents/modal";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import "../../../pages/procedureDetail/createProcedureDetail/style/index.scss";
import ProcedureInfoDetailBase from "./procedureInfoDetailBase";

import { getPendingAction } from "../../../../store/actions/procedureDetailPageActions";
import { PendingActionTypes } from "../../../../store/actions/constants";
import { checkLatestProcedureInfo } from "../../../pages/procedureDetail/utils";
import { debounce } from "lodash-es";
import { HeaderWithReminder } from "app/pages/procedureDetail/createProcedureDetail/utils";

const initProcedureInfoData = {
  procedureName: null,
  procedureInformationId: null,
  primaryProcedureOwnerId: null,
  primaryProcedureOwnerName: null,
  procedureOwnerId: null,
  procedureStatus: null,
  note: "",
  reason: null,
  ppoChange: false,
  poChange: false,
};
const procedureInfoRef = createRef();
const procedureInfoModalRef = createRef();
export default class ProcedureInfoSection extends FileSectionBase {
  constructor(props: any) {
    super(props);
    this.state = {
      procedureInfoSubmitData: initProcedureInfoData,
      preProcedureInfoSubmitData: initProcedureInfoData,
      procedureStatus: "",
      ppoList: [],
      isProcedureInfoEditToolTipOpen: false,
      isProcedureInfoModalChange: false,
      PPOmessageCode: null,
      POmessageCode: null,
      isPPODisabled: false,
      isPODisabled: false,
      isScrollModalOpen: false,
      isModalOpen: false,
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      handleModalConfirm: () => {
        //empty function
      },
      handleModalCancel: () => {
        //empty function
      },
      scrollModalContent: null,
      scrollModalTitle: null,
      modalChildContent: null,
    };
  }

  setProcedureStatus = (result: any) => {
    this.setState({
      procedureStatus: this.getProcedureStatus(result),
    });
  };

  setPpoList = (result: any) => {
    this.setState({
      ppoList: result,
    });
  };

  hideAllModal = () => {
    this.setState({
      isModalOpen: false,
      isScrollModalOpen: false,
      scrollModalContent: "",
      scrollModalTitle: "",
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  createProcedureInfo = (response: any, ref: any) => {
    const preProcedureInfoSubmitData = {
      procedureName: null,
      procedureInformationId: null,
      procedureStatus: response.procedureStatus,
      isPMPExcluded: response.isExcluded,
      primaryProcedureOwnerId: response.primaryProcedureOwnerID,
      primaryProcedureOwnerName: response.primaryProcedureOwner,
      procedureOwnerId: response.procedureOwnerID,
      note: response.note || "",
      ppoChange: false,
      poChange: false,
    };
    this.setState({
      procedureInfoSubmitData: {
        procedureName: null,
        procedureInformationId: null,
        procedureStatus: response.procedureStatus,
        isPMPExcluded: response.isExcluded,
        primaryProcedureOwnerId: response.primaryProcedureOwnerID,
        primaryProcedureOwnerName: response.primaryProcedureOwner,
        procedureOwnerId: response.procedureOwnerID,
        note: response.note,
        ppoChange: false,
        poChange: false,
      },
      preProcedureInfoSubmitData: {
        ...preProcedureInfoSubmitData,
      },
      PPOmessageCode: response.checkEditPpo.messageCode,
      POmessageCode: response.checkEditPo.messageCode,
    });
    if (ref.current !== null) {
      ref.current.updatePPO(response.primaryProcedureOwnerID, true);
      ref.current.updatePPOName(response.primaryProcedureOwner, true);
      ref.current.updatePO(response.procedureOwnerID, true);
      ref.current.updatePOName(response.procedureOwner, true);
      ref.current.updateNote(response.note, true);
      ref.current.updateReason(response?.reason, true);
      ref.current.updateProcedureStatus(response.procedureStatusID, true);
      ref.current.updateProcedureExcluded(response.isExcluded, true);
      ref.current.updatePreProcedureInfoSubmitData({
        ...preProcedureInfoSubmitData,
      });
    }
  };

  createProcedureInfoData = (
    createProcedureInfoRef = procedureInfoRef,
    propsProcedureAccountId = null
  ) => {
    this.props.showLoading();
    const procedureId = this.props.procedureId;
    const procedureTaskId = this.props.procedureTaskId || null;
    ProcedureDetailService.getProcedureInfoSection(
      {
        procedureId: procedureId,
        ProcedureTaskId: procedureTaskId,
        procedureAccountId: propsProcedureAccountId,
      },
      (response: any) => {
        this.createProcedureInfo(response, createProcedureInfoRef || procedureInfoRef);
        this.props.hideLoading();
        this.props.setProcedureJbStatusId(response.procedureStatusID);
      },
      (error: any) => {
        // this._alertError("Get procedure information error!");
        console.log(error);
      }
    );
  };

  _procedureInfoSubmitSuccess = (response: any, ref: any) => {
    ref.current.cancelIsChange();
    this.setState({
      preProcedureInfoSubmitData: { ...this.state.procedureInfoSubmitData },
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        ppoChange: false,
        poChange: false,
      },
    });
    this.props.procedureInfoSubmitSuccess();
    this.handleResetLock("ProcedureInfo");
    this._alertSuccess("Submit Successful");
    this.props.procedureId && this.props.setIsProcedureInfoModalChange();
    this.createProcedureInfoData(ref);
  };

  handleSubmitProcedureInfoModalConfirm = debounce(
    (ref) => {
      this.hideAllModal();
      this.props.showLoading();
      const para = {
        pmpExcluded: true,
        procedureId: this.props.procedureId,
        procedureTaskId: this.props.procedureTaskId,
        oldPrimaryProcedureOwnerId: this.state.preProcedureInfoSubmitData.primaryProcedureOwnerId,
        oldProcedureOwnerId: this.state.preProcedureInfoSubmitData.procedureOwnerId,
        primaryProcedureOwnerId: this.state.procedureInfoSubmitData.ppoChange
          ? this.state.procedureInfoSubmitData.primaryProcedureOwnerId
          : null,
        procedureOwnerId: this.state.procedureInfoSubmitData.poChange
          ? this.state.procedureInfoSubmitData.procedureOwnerId
          : null,
        reason: this.state.procedureInfoSubmitData.reason,
        note: this.state.procedureInfoSubmitData.note,
        returnReason: "",
      };

      ProcedureDetailService.submitProcedureInfo(
        para,
        (response: any) => this._procedureInfoSubmitSuccess(response, ref),
        this._submitError
      );
    },
    1000,
    {
      leading: true,
      trailing: false,
    }
  );

  procedureInformationOnSubmit = async () => {
    this.props.showLoading();
    const shouldContinue = await checkLatestProcedureInfo({
      actionType: PendingActionTypes.ProcedureFilesApplyForJB,
      procedureTaskId: this.props.procedureTaskId,
      callbackType: "ONLY_MESSAGE",
    });
    this.props.hideLoading();
    if (!shouldContinue) return;

    this.setState({
      isModalOpen: true,
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      modalChildContent: "Are you sure to submit?",
      handleModalConfirm: () => this.handleSubmitProcedureInfoModalConfirm(procedureInfoRef),
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  handleCancelProcedureInfoModalConfirm = (ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.preProcedureInfoSubmitData,
        ppoChange: false,
        poChange: false,
      },
    });
    this.hideModal();
    this.hideScrollModal();
    this.handleResetLockWithoutRefresh("ProcedureInfo");
    this.props.setActionType(null);
  };

  procedureInformationOnCancel = () => {
    this.setState({
      isModalOpen: true,
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      modalChildContent: "Are you sure to quit without saving?",
      handleModalConfirm: () => this.handleCancelProcedureInfoModalConfirm(procedureInfoRef),
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  handlePpoChange = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        primaryProcedureOwnerId: value,
        ppoChange: true,
      },
    });
    ref.current.updatePPO(value);
  };

  handlePoChange = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        procedureOwnerId: value,
        poChange: true,
      },
    });
    ref.current.updatePO(value);
  };

  handleProStatusChange = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        procedureStatus: value,
      },
    });
    ref.current.updateProcedureStatus(value);
  };

  handleProExcludedChange = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        procedureExcluded: value,
      },
    });
    ref.current.updateProcedureExcluded(value);
  };

  handleStringTrim = (value: any) => {
    return value?.trim() ? value.trim() : null;
  };

  changePPOReason = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        reason: this.handleStringTrim(value),
      },
    });
    ref.current.updateReason(value);
  };

  changePOReason = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        reason: this.handleStringTrim(value),
      },
    });
    ref.current.updateReason(value);
  };

  handleNoteChange = (value: any, ref: any) => {
    this.setState({
      procedureInfoSubmitData: {
        ...this.state.procedureInfoSubmitData,
        note: value,
      },
    });
    ref.current.updateNote(value);
  };

  setScrollModalState = (params: any) => {
    const { PPOmessageCode, POmessageCode, isPPODisabled, isPODisabled } = params;
    this.setState({
      isScrollModalOpen: true,
      isProcedureInfoEditToolTipOpen: false,
      scrollModalContent: (
        <ProcedureBlock
          child={this.handleReturnProcedureInfo({
            procedureInfoSubmitData: this.state.procedureInfoSubmitData,
            procedureStatus: this.state.procedureStatus,
            ppoList: this.state.ppoList,
            isShowProcedureInfoEdit: false,
            PPOmessageCode: PPOmessageCode,
            POmessageCode: POmessageCode,
            isPPODisabled: isPPODisabled,
            isPODisabled: isPODisabled,
            isShowActions: true,
            noteDisabled: false,
            reasonDisabled: false,
            ref: procedureInfoModalRef,
            title: "",
            hintMsg: this.props.hintMsg,
          })}
          isShowArrow={false}
          className="processProcedureModalBlock procedureInfoModalBlock"
          isOpen={true}
        />
      ),
      scrollModalTitle: <HeaderWithReminder>Procedure Information</HeaderWithReminder>,
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  checkPOEdit = (isLock: any, lockUser: any) => {
    const { procedureId, procedureTaskId, procedureAccountId } = this.props;
    const para = {
      procedureId: procedureId,
      procedureAccountId: procedureAccountId,
      procedureTaskId: procedureTaskId,
      procedureOwnerID: this.state.procedureInfoSubmitData.procedureOwnerId,
    };

    ProcedureDetailService.checkPOEdit(
      para,
      (response: any) => {
        const { result } = response;
        this.checkPPOEdit(isLock, lockUser, !result);
        this.props.hideLoading();
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  };

  checkPPOEdit = (isLock: any, lockUser: any, isPODisabled: any) => {
    const { procedureId, procedureTaskId, procedureAccountId } = this.props;
    const para = {
      procedureId: procedureId,
      procedureAccountId: procedureAccountId,
      procedureTaskId: procedureTaskId,
      primaryProcedureOwnerID: this.state.procedureInfoSubmitData.primaryProcedureOwnerId,
    };

    ProcedureDetailService.checkPPOEdit(
      para,
      (response: any) => {
        const { result } = response;
        this.setScrollModalState({
          isLock,
          lockUser,
          isPODisabled,
          isPPODisabled: !result,
        });
        this.props.setActionType(this.props.actionType);
        this.createProcedureInfoData(procedureInfoModalRef);
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  };

  handleProcedureInfoLock = (isLock: any, lockUser: any) => {
    this.setScrollModalOpen(true);
    this.handleReturnProcedureInfo({
      procedureInfoSubmitData: this.state.procedureInfoSubmitData,
      procedureStatus: this.state.procedureStatus,
      ppoList: this.state.ppoList,
      isShowProcedureInfoEdit: false,
      PPOmessageCode: null,
      POmessageCode: null,
      isPPODisabled: false,
      isPODisabled: false,
      isShowActions: true,
      noteDisabled: false,
      reasonDisabled: false,
      isLock,
      lockUser,
      ref: procedureInfoRef,
      title: "",
      hintMsg: this.props.hintMsg,
    });
  };

  handleProcedureInfoUnlock = (isLock: any, lockUser: any) => {
    this.checkPOEdit(isLock, lockUser);
  };

  checkProcedureInfoWhetherLock = (isLock: any, lockUser: any) => {
    this.props.hideLoading();
    if (isLock) {
      this.props.setLock(`${lockUser} is editing this section.`);
      // @ts-ignore
      this.handleProcedureInfoLock();
    } else {
      this.props.setLock("");
      // @ts-ignore
      this.handleProcedureInfoUnlock();
    }
  };

  handleProcedureInfoEditClick = async () => {
    this.props.showLoading();
    await checkLatestProcedureInfo({
      actionType: PendingActionTypes.ProcedureInfoEdit,
      procedureTaskId: this.props.procedureTaskId,
    });

    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: this.props.actionType,
      timeOutMins: timeOutMins,
    };
    ProcedureDetailService.checkSectionLock(
      para,
      (response: any) =>
        this.checkProcedureInfoWhetherLock(response.data.isLocked, response.data.lockUser),
      (response: any) => {
        console.log(response.message);
        this.props.hideLoading();
      }
    );
  };

  componentDidUpdate() {
    const pendingAction = getPendingAction();
    if (pendingAction === PendingActionTypes.ProcedureInfoEdit) {
      this.handleProcedureInfoEditClick();
    }
  }

  setScrollModalOpen = (isOpen: any) => {
    this.setState({
      isProcedureInfoEditToolTipOpen: isOpen,
    });
  };

  closeScrollModal = () => {
    this.handleCancelProcedureInfoModalConfirm(procedureInfoRef);
    this.hideScrollModal();
  };

  handleReturnProcedureInfo = (obj: any) => {
    const {
      procedureInfoSubmitData,
      procedureStatus,
      ppoList,
      isShowProcedureInfoEdit,
      PPOmessageCode,
      POmessageCode,
      isPPODisabled,
      isPODisabled,
      isShowActions,
      noteDisabled,
      reasonDisabled,
      ref,
      title,
      poChange,
      hintMsg,
      isSection,
    } = obj;
    return (
      <ProcedureInfoDetailBase
        ref={ref}
        onSubmit={this.procedureInformationOnSubmit}
        onCancel={this.procedureInformationOnCancel}
        preProcedureInfoSubmitData={this.state.preProcedureInfoSubmitData}
        submitData={procedureInfoSubmitData}
        handlePpoChange={this.handlePpoChange}
        handlePoChange={this.handlePoChange}
        handleProStatusChange={this.handleProStatusChange}
        handleNoteChange={this.handleNoteChange}
        changePPOReason={this.changePPOReason}
        changePOReason={this.changePOReason}
        currentRef={ref}
        isShowActions={isShowActions}
        procedureStatus={procedureStatus}
        ppoList={ppoList}
        PPOmessageCode={PPOmessageCode}
        POmessageCode={POmessageCode}
        isPPODisabled={isPPODisabled}
        isPODisabled={isPODisabled}
        isShowProcedureInfoEdit={isShowProcedureInfoEdit}
        isEditToolTipOpen={this.state.isProcedureInfoEditToolTipOpen}
        handleEditClick={() => this.handleProcedureInfoEditClick()}
        onBlur={() => this.setScrollModalOpen(false)}
        noteDisabled={noteDisabled}
        reasonDisabled={reasonDisabled}
        title={title}
        poChange={poChange}
        hintMsg={hintMsg}
        isSection={isSection}
      />
    );
  };

  updateModalWidth = () => {
    if (!this.state.isScrollModalOpen) return;
    this.setState({
      ...this.state,
    });
  };

  componentDidMount() {
    this.updateModalWidth();
    window.addEventListener("resize", this.updateModalWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateModalWidth);
  }

  render() {
    const modalWidth =
      document.getElementsByClassName("procedureBlock")[0] !== undefined &&
      // @ts-ignore
      document.getElementsByClassName("procedureBlock")[0].offsetWidth;
    return (
      <>
        <ProcedureBlock
          child={this.handleReturnProcedureInfo({
            procedureInfoSubmitData: this.state.procedureInfoSubmitData,
            procedureStatus: this.state.procedureStatus,
            ppoList: this.state.ppoList,
            isShowProcedureInfoEdit: this.props.isShowProcedureInfoEdit,
            isPPODisabled: true,
            isPODisabled: true,
            isShowActions: false,
            noteDisabled: true,
            reasonDisabled: true,
            ref: procedureInfoRef,
            title: "Procedure Information",
            hintMsg: this.props.hintMsg,
            PPOmessageCode: this.state.PPOmessageCode,
            POmessageCode: this.state.POmessageCode,
            isSection: true,
          })}
          isShowArrow={false}
          className="processProcedureBlock procedureInfoBlock"
          isOpen={true}
        />
        <NormalModal
          testid="procedure-info-modal"
          okText={this.state.modalOkText}
          cancelText={this.state.modalCancelText}
          childContent={<p className="fs-16">{this.state.modalChildContent}</p>}
          isModalOpen={this.state.isModalOpen}
          handleOk={this.state.handleModalConfirm}
          handleCancel={() => {
            this.state.handleModalCancel();
            this.hideModal();
          }}
          closable={false}
          className="modalWithScroll"
          okButtonTestid="procedure-info-modal-ok-btn"
          cancelButtonTestid="procedure-info-modal-cancel-btn"
        />
        <ModalWithScroll
          testid="procedure-info-scroll-modal"
          isModalOpen={this.state.isScrollModalOpen}
          modalContent={this.state.scrollModalContent}
          title={this.state.scrollModalTitle}
          handleCloseClick={() => {
            this.closeScrollModal();
            this.props.setActionType(null);
          }}
          width={modalWidth}
          actionType={this.props.actionType}
        />
      </>
    );
  }
}
